import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const PresentationButton = ({ presentationElements, presentationMode, onStartPresentation, onStopPresentation, }) => {
    return (_jsxs("button", { onClick: presentationMode ? onStopPresentation : onStartPresentation, style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            padding: '8px 16px',
            backgroundColor: presentationMode ? '#ff4444' : '#4CAF50',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '500',
            transition: 'all 0.2s ease',
            pointerEvents: 'auto',
        }, onMouseEnter: (e) => {
            e.currentTarget.style.backgroundColor = presentationMode ? '#cc3333' : '#45a049';
        }, onMouseLeave: (e) => {
            e.currentTarget.style.backgroundColor = presentationMode ? '#ff4444' : '#4CAF50';
        }, disabled: !(presentationElements === null || presentationElements === void 0 ? void 0 : presentationElements.length), children: [presentationMode ? (_jsx("div", { style: { width: '8px', height: '8px', backgroundColor: '#fff' } })) : (_jsx("div", { style: { width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#fff' } })), presentationMode ? 'Остановить презентацию' : 'Начать презентацию'] }));
};
